var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('main-header'),_c('v-main',{staticClass:"wxapp-main-page",class:this.isLayoutCentered ? 'centered-main-page' : false},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }